module.exports = __webpack_public_path__ + "img/ico_carta.d00d3d99.svg";